import { Notification } from "element-ui";
import { api } from "../../gateways/unilabApi";

export default {
  getManifolds() {
    return new Promise((resolve, reject) => {
      api
        .get("manifold/list")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Notification.error({
            title: "Attenzione",
            message: error
          });
          reject(error);
        });
    });
  },

  getManifoldsByMaterialId(idMaterial) {
    return new Promise((resolve, reject) => {
      api
        .get("manifold/listByMaterial", {
          params: {
            idMaterial
          }
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Notification.error({
            title: "Attenzione",
            message: error
          });
          reject(error);
        });
    });
  },

  getCalculationTypes() {
    return new Promise((resolve, reject) => {
      api
        .get("manifold/listCalculationTypes")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Notification.error({
            title: "Attenzione",
            message: error
          });
          reject(error);
        });
    });
  },

  getDispositionTypes() {
    return new Promise((resolve, reject) => {
      api
        .get("manifold/listDispositionTypes")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Notification.error({
            title: "Attenzione",
            message: error
          });
          reject(error);
        });
    });
  }
};
